<template>
  <div class="img_announcements_view">
    <b-container fluid class="bv-example-row">
      <b-row>
        <b-col cols="8">
          <card>
            <ImgAnnouncementList
              ref="announcementList"
              v-on:selectedItem="onListSelection"
              v-on:newItem="this.createNewAnn"
            ></ImgAnnouncementList>
          </card>
        </b-col>
        <b-col cols="4">
          <InfoCard v-if="action == ''"></InfoCard>
          <b-card v-else>
            <b-alert
              variant="alert"
              :visible="selectedAnnouncementCount != 1"
              >{{ $t('announcement_view.select_hint_txt') }}</b-alert
            >
            <b-tabs pills card align="center" fill>
              <b-tab :title="$t('announcement_view.content')">
                <b-card-text>
                  <ImgAnnouncementEditForm
                    ref="txtFormEditor"
                    :creatingNew="this.creatingNew"
                    v-bind:editordata="this.formData"
                  ></ImgAnnouncementEditForm>
                </b-card-text>
              </b-tab>
              <b-tab :title="$t('announcement_view.schedules')">
                <b-collapse :visible="editorsVisible">
                  <AnnouncementScheduleEditor
                    ref="schedEditor"
                    :creatingNew="this.creatingNew"
                    :scheduleList="this.scheduleList"
                  ></AnnouncementScheduleEditor>
                </b-collapse>
                <b-collapse :visible="!editorsVisible">
                  {{ $t('announcement_view.select_hint_txt') }}
                </b-collapse>
                <b-card-text> </b-card-text>
              </b-tab>
              <b-tab :title="$t('announcement_view.targets')">
                <b-collapse :visible="editorsVisible">
                  <AnnouncementTargetControl
                    ref="targetCtrl"
                    :creatingNew="this.creatingNew"
                    :targetdata="this.targetList"
                    :notValidTargets="notValidTargets"
                  ></AnnouncementTargetControl>
                </b-collapse>
                <b-collapse :visible="!editorsVisible">
                  {{ $t('announcement_view.select_hint_txt') }}
                </b-collapse>
              </b-tab>
            </b-tabs>
            <FormButtons
              ref="formButtonit"
              @reset="this.resetAnnouncementData"
              @submit="this.submitAnnouncementData"
              @remove="this.removeAnnouncement"
              :disableReset="formButtons.enabled"
              :disableSubmit="formButtons.enabled"
              :disableRemove="formButtons.removeDisabled"
              :itemid="this.tiedoteOtsikko"
            >
            </FormButtons>
            <RequestInfo type="save" :ok="ok" :error="error" :loader="loading" />
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import announcements from '@/store/announcements/announcements'

import ImgAnnouncementList from '@/components/Announcements/ImgAnnouncementList.vue'
import ImgAnnouncementEditForm from '@/components/Announcements/ImgAnnouncementEditForm.vue'
import AnnouncementTargetControl from '@/components/Announcements/AnnouncementTargetControl.vue'
import AnnouncementScheduleEditor from '@/components/Announcements/AnnouncementScheduleEditor.vue'
import FormButtons from '@/components/Misc/FormButtons'
import RequestInfo from '@/components/Misc/RequestInfo'

export default {
  name: 'ImageAnnouncements',
  components: {
    ImgAnnouncementList,
    ImgAnnouncementEditForm,
    AnnouncementTargetControl,
    AnnouncementScheduleEditor,
    FormButtons,
    RequestInfo,
  },
  data: function () {
    return {
      formButtons: { disabled: true, removeDisabled: true },
      editorsVisible: false,
      targetList: [],
      formData: null,
      scheduleList: [],
      creatingNew: false,
      selectedAnnouncementCount: 0,
      notValidTargets: ['VM'],
      action: '',
      ok: false,
      error: false,
      loading: false
    }
  },
  computed: {
    tiedoteOtsikko: function () {
      if (this.formData == null) {
        return ''
      }
      if (
        this.formData != 'undefined' &&
        this.formData.otsikko != 'undefined'
      ) {
        return this.formData.otsikko
      } else {
        return ''
      }
    },
  },
  beforeCreate() {
    if (!this.$store.state.announcements) {
      this.$store.registerModule('announcements', announcements)
    }
  },
  mounted() {
    if (this.$route.query.command && this.$route.query.command == 'new') {
      this.createNewAnn()

      var stopTunnus = this.$route.query.targetStop
      if (stopTunnus) {
        this.targetList.push({
          id: stopTunnus,
          type: 'pysakki',
          label: '<Stop Selected from Map>',
        })
      }

      var device = this.$route.query.targetDevice
      if (device) {
        this.targetList.push({ id: device, type: 'display', label: device })
      }
    }
  },
  methods: {
    onListSelection(itemi) {
      var selectedAnnCount = 0
      if (this.creatingNew) {
        // ollaan tekemässä uutta tiedotetta. tiedotteen valinta listasta ei tee mitään
        return
      }
      if (Array.isArray(itemi)) {
        selectedAnnCount = itemi.length
        this.selectedAnnouncementCount = itemi.length
      } else {
        selectedAnnCount = 0
        this.selectedAnnouncementCount = 0
      }

      if (selectedAnnCount == 1) {
        var copy = Object.assign({}, itemi[0])
        this.formData = copy
        this.scheduleList = copy.ajastusList
        this.targetList = []
        this.$store
          .dispatch('announcements/getAnnouncementTargets', copy.tunnus)
          .then(
            (data) => {
              this.targetList = data
            },
            () => {
              this.$travellerGetDataError()
            }
          )
        this.formButtons.disabled = false
        this.formButtons.removeDisabled = false
        this.editorsVisible = true
      } else {
        // deselect tilanne
      }
      this.action = 'item'
    },
    createNewAnn: function () {
      this.creatingNew = true
      this.$refs.announcementList.deselectAll()
      this.targetList = []
      this.formButtons.disabled = false
      this.formButtons.removeDisabled = true
      this.formData = null
      this.editorsVisible = true
      this.action = 'new'
    },
    submitAnnouncementData() {
      this.loading = true
      this.ok = this.error = false
      var txt = this.$refs.txtFormEditor.collectFormData()
      var sched = this.$refs.schedEditor.collectScheduleData()
      var targets = this.$refs.targetCtrl.getTargets()

      var submitData = txt

      if(sched.length > 0 && sched[0].validityBegins === 'Invalid date') {
        sched[0].validityBegins = null
      }
      if(sched.length > 0 && sched[0].validityEnds === 'Invalid date') {
        sched[0].validityEnds = null
      }

      submitData.ajastusList = sched
      submitData.targets = targets
      this.$store.dispatch('announcements/storeImgAnnouncement', submitData)
        .then(() => {
          this.ok = true
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetAnnouncementData() {
      this.$refs.txtFormEditor.resetForm()
      this.formButtons.disabled = true
      this.formButtons.removeDisabled = true
      this.editorsVisible = true
      this.creatingNew = false
    },
    removeAnnouncement() {
      if (this.formData.tunnus != undefined) {
        var id = this.formData.tunnus
        this.$travellerRemove()
        this.$store
          .dispatch('announcements/removeAnnouncement', id)
          .then(() => {
            this.$store.dispatch('announcements/getImageAnnouncementList')
            this.$travellerRemoved()
          })
        this.resetAnnouncementData()
      }
    },
  },
}
</script>
